import { render, staticRenderFns } from "./InputGroup.vue?vue&type=template&id=0b9ac24e&"
import script from "./InputGroup.vue?vue&type=script&lang=js&"
export * from "./InputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports